module.exports = __webpack_public_path__ + "static/media/cloze-rabbit-hole-decorations.1202c073.svg";